import { useMediaQuery } from '@chakra-ui/react';

import { EquipmentsGuideMobileView } from './mobile-view';
import EquipmentsGuideTable from './table';

export const EquipmentsGuide = () => {

  const [isLarge] = useMediaQuery('(min-width: 768px)', {
    fallback: true
  });
  
  if (isLarge) {
    return <EquipmentsGuideTable  />;
  }

  return <EquipmentsGuideMobileView />;
};